import classNames from "classnames";
import React, { CSSProperties, ReactNode } from "react";

type FormRowProps = {
    small?: boolean;

    label?: string;
    labelWidth?: any;
    labelClassName?: string;
    labelStyle?: CSSProperties | undefined;
    htmlFor?: string;
    className?: string;
    controlClassName?: string;

    width?: any;
    height?: any;
    maxWidth?: any;
    maxLabelWidth?: any;
    style?: CSSProperties | undefined;

    children?: ReactNode;
    [x: string]: any;
};

export const FormRow = ({
    small,

    label,
    labelWidth,
    labelClassName,
    labelStyle,
    htmlFor,
    className,
    controlClassName,

    width,
    height,
    maxWidth,
    maxLabelWidth,
    style,

    children,
    props,
}: FormRowProps) => {
    const break_point =
        typeof labelWidth !== "string" ? "md" : labelWidth.startsWith("lg") ? "lg" : labelWidth.startsWith("xl") ? "xl" : "md";
    labelWidth = typeof labelWidth !== "string" || labelWidth.indexOf("-") === -1 ? labelWidth : labelWidth.split("-")[1];
    labelWidth = labelWidth * 1;

    const label_break_point = !labelWidth ? "" : `col-${break_point}-${labelWidth}`;
    const control_break_point = !labelWidth ? "" : `col-${break_point}-${12 - labelWidth}`;

    var cn = classNames("bd-form-row", className, { "row gx-3": labelWidth });
    var cnLabel = classNames(labelClassName, "form-label", {
        [`text-start text-${break_point}-end col-form-label col-12 ${label_break_point}`]: labelWidth,
        [`d-none d-${break_point}-block`]: label == null && labelWidth,
        "d-none": label == null && !labelWidth,
        "text-muted small m-0": small,
    });
    let label_style = maxLabelWidth ? { ...labelStyle, maxWidth: maxLabelWidth } : { ...labelStyle };

    let field_comp = children;
    if (labelWidth > 0) {
        field_comp = (
            <div className={classNames(controlClassName, `d-flex align-items-center col-12 ${control_break_point}`)}>{field_comp}</div>
        );
    } else {
        field_comp = (
            <div className={classNames(controlClassName, `d-flex align-items-center col-12 ${control_break_point}`)}>{field_comp}</div>
        );
    }

    return (
        <>
            <div className={cn} style={{ ...style, maxWidth, width, height }} {...props}>
                <label className={cnLabel} htmlFor={htmlFor} style={label_style}>
                    {label === "" || label === " " ? <>&nbsp;</> : label}
                </label>
                {field_comp}
            </div>
        </>
    );
};
